// Ebooks
(function () {
  'use strict';
  /* $('.ebook-lista').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: false,
  }); */
})();

// Vídeos
(function () {
  'use strict';

  const $modalVideo = $('#modal-video-academy');

  // Exibe o modal do vídeo ao clicar no bloco
  $('.open-video-academy').on('click', function (ev) {
    ev.preventDefault();
    const $btn = $(this);
    const videoCod = $btn.data('video');
    const videoTitle = $btn.data('title');
    const videoPlataform = $btn.data('plataform');
    if (videoCod && videoCod != '' && !$btn.hasClass('disabled')) {
      $modalVideo.find('.modal-body').html('').append(createVideo(videoPlataform, videoCod));
      $modalVideo.find('.modal-footer').html(videoTitle);
      $('body').addClass('backdrop-video');
      $modalVideo.modal('show');
    }
  });

  // Remove o vídeo ao fechar o modal
  $modalVideo.on('hide.bs.modal', function (event) {
    $modalVideo.find('.modal-body').html('');
    $modalVideo.find('.modal-footer').html('');
    $('body').removeClass('backdrop-video');
  });

  // Cria um elemento Iframe de vídeo
  function createVideo(videoPlataform, videoCod) {
    let $iframe;
    console.log(videoPlataform, videoCod);
    if (videoPlataform == 'youtube') {
      $iframe = `<div class="embed-responsive embed-responsive-16by9"><iframe class="embed-responsive-item" src="https://www.youtube.com/embed/${videoCod}?controls=1&autoplay=1" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>`;
    } else if (videoPlataform == 'vimeo') {
      $iframe = `<div class="embed-responsive embed-responsive-16by9"><iframe class="embed-responsive-item" src="https://player.vimeo.com/video/${videoCod}?title=0&byline=0&portrait=0&autoplay=1&color=#14a67a" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>`;
    }
    return $iframe;
  }
})();
